import { type FC } from 'react'
import { Button } from '../../../components/Button/Button'

interface TrialSuccessProps {
  buttonLabel: string
  onButtonClick: () => void
}

export const TrialSuccess: FC<TrialSuccessProps> = ({ buttonLabel, onButtonClick }) => {
  return (
    <div className='d-flex flex-column gap-3 align-items-center text-center'>
      <div className='paragraph-medium'>
        You've just unlocked the powerful features for financial advisors. It's time to boost productivity and scale your practice.
      </div>
      <div className='d-flex align-items-center justify-content-center'>
        <Button variant='primary' className='button-medium' onClick={onButtonClick}>
          {buttonLabel}
        </Button>
      </div>
    </div>
  )
}
